import { Component, OnInit } from '@angular/core';

//services
import { TimeoutService } from '../../core/services/timeout.service';

@Component({
    selector: 'app-home-layout',
    templateUrl: './home-layout.component.html',
    styleUrls: ['./home-layout.component.css'],
    standalone: false
})
export class HomeLayoutComponent implements OnInit {
  constructor(private timeoutService: TimeoutService) {}

  ngOnInit(): void {
    this.timeoutService.initializeTimeoutConfig();
  }
}
